import type {z} from "zod";

import {AddMaterialFunctionBody} from "@project/sdk/engineering/zod";

export const addMaterialFunctionFormSchema = AddMaterialFunctionBody;
export type AddMaterialFunctionFormPayload = z.output<typeof addMaterialFunctionFormSchema>;

export const draftAddMaterialFunctionFormSchema = addMaterialFunctionFormSchema.partial();
export type DraftAddMaterialFunctionFormPayload = z.output<
  typeof draftAddMaterialFunctionFormSchema
>;
